import dayjs from 'dayjs'
import isLeapYear from 'dayjs/plugin/isLeapYear'
import duration from 'dayjs/plugin/duration'
import utc from 'dayjs/plugin/utc' // import plugin
import 'dayjs/locale/zh-cn' // import locale

dayjs.extend(isLeapYear)
dayjs.extend(duration)
dayjs.extend(utc) // use plugin
dayjs.locale('zh-cn')

export default dayjs

